// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"105":"cart-handler","172":"list-handler"}[chunkId] + "." + {"105":"532f4996","172":"db06104d"}[chunkId] + ".js";
};